import * as React from 'react'

import isEmpty from 'lodash/isEmpty'

import { useUnsafeAsyncData } from 'modules/core/hooks/useAsyncData'

import questionGroups from 'modules/reviews/store/collections/questionGroups'
import QuestionGroup from 'modules/reviews/store/models/QuestionGroup'

export function useQuestionGroup(
  questionGroupId: number,
  fetchFromShow?: boolean
): {
  loading: boolean
  questionGroup: QuestionGroup | null | undefined
  refresh: () => Promise<void>
} {
  const [questionGroup, setQuestionGroup] = React.useState(questionGroups.get(questionGroupId))

  const fetchQuestionGroup = async ({ isUpdate = !!fetchFromShow } = {}) => {
    const _questionGroup =
      (!isUpdate && questionGroup) ||
      new QuestionGroup({
        id: questionGroupId,
      })

    const data = await _questionGroup.fetch()

    if (!isEmpty(data)) setQuestionGroup(_questionGroup)
  }

  const { loading } = useUnsafeAsyncData(fetchQuestionGroup, [questionGroupId])

  const refresh = async () => {
    await fetchQuestionGroup({
      isUpdate: true,
    })
  }

  return {
    loading,
    questionGroup,
    refresh,
  }
}
